"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styled = require("../styled.banners");

var _addonKnobs = require("@storybook/addon-knobs");

var _basicBannerProps = require("./basicBannerProps");

var _basicBannerProps2 = _interopRequireDefault(_basicBannerProps);

var _baseHelper = require("../../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

var _inlineDiv = require("../../../inlineDiv");

var _inlineDiv2 = _interopRequireDefault(_inlineDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropValue = _baseHelper2.default.getPropValue;


var BasicBanner = function BasicBanner(props) {
  var newProps = _extends({}, _basicBannerProps2.default.props, props);
  var style = newProps.style,
      body = newProps.body,
      content = newProps.content,
      media = newProps.media,
      links = newProps.links,
      updateProps = newProps.updateProps,
      setData = newProps.setData,
      isEditMode = newProps.isEditMode;


  var sectionProps = {
    background: getPropValue("text", "background", media.background, "media"),
    contentColor: getPropValue("text", "contentColor", style.contentColor, "style"),
    contentFontSize: getPropValue("text", "contentFontSize", style.contentFontSize, "style")
  };

  var titleProps = {
    headingFontSize: getPropValue("text", "headingFontSize", style.headingFontSize, "style"),
    headingColor: getPropValue("text", "headingColor", style.headingColor, "style"),
    bottomSpace: getPropValue("text", "bottomSpace", style.bottomSpace, "style")
  };

  var containerProps = {
    maxWidth: getPropValue("text", "maxWidth", style.containerWidth, "style")
  };

  var title = getPropValue("text", "title", content.title, "content");
  var bannerContent = getPropValue("text", "content", content.content, "content");
  var linkUrl = getPropValue("text", "linkUrl", links.linkUrl, "content");
  var linkTitle = getPropValue("text", "linkTitle", links.linkTitle, "content");

  var paragraphStyle = {
    contentSpace: getPropValue("text", "contentSpace", style.contentSpace, "style")
  };
  return _react2.default.createElement(
    _styled.Section,
    _extends({}, sectionProps, { className: "position-relative mb-4 BasicBanner" }),
    _react2.default.createElement(
      _styled.StyledContainer,
      _extends({}, containerProps, { className: "container" }),
      _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _styled.Title,
          _extends({}, titleProps, { className: "text-center" }),
          _react2.default.createElement(_inlineDiv2.default, {
            isEditMode: isEditMode,
            keyProperty: "title",
            property: "content",
            setData: setData,
            updateProps: updateProps,
            value: title
          })
        ),
        _react2.default.createElement(
          _styled.Paragraph,
          paragraphStyle,
          _react2.default.createElement(_inlineDiv2.default, {
            isEditMode: isEditMode,
            keyProperty: "content",
            property: "content",
            setData: setData,
            updateProps: updateProps,
            value: bannerContent
          })
        )
      )
    )
  );
};

exports.default = BasicBanner;